const ITEMS = [
  "Precision Diagnostics",
  "Brake Rebuild",
  "Engine Service",
  "Suspension & Steering",
  "Electrical & Battery",
  "Alignment Service",
  "New Brunswick NJ",
];

function Row({ ariaHidden = false }) {
  return (
    <div aria-hidden={ariaHidden} className="flex shrink-0 items-center">
      {ITEMS.map((item) => (
        <span key={item} className="flex items-center">
          <span className="whitespace-nowrap px-6 font-display text-xl uppercase text-zinc-950 md:px-10 md:text-3xl">
            {item}
          </span>
          <span className="text-xl text-zinc-950/50 md:text-2xl">•</span>
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <section aria-label="Services" className="overflow-hidden bg-gold py-4 md:py-5">
      <div className="flex w-max animate-marquee">
        <Row />
        <Row ariaHidden />
      </div>
    </section>
  );
}
